import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShieldIconNew = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.7142 1.08892C11.9039 1.06151 12.0966 1.06151 12.2863 1.08892C12.5049 1.12051 12.7084 1.19737 12.8699 1.25839L12.9132 1.2747L18.4056 3.33422C19.0234 3.56488 19.566 3.76743 19.9838 4.13565C20.3493 4.45778 20.6309 4.86407 20.8041 5.31941C21.0022 5.83992 21.0014 6.41904 21.0004 7.07848L21.0003 12.0004C21.0003 14.827 19.463 17.1836 17.8012 18.9148C16.1283 20.6576 14.2143 21.8885 13.2022 22.479L13.1612 22.503C12.9765 22.6115 12.7368 22.7522 12.4196 22.8202C12.1602 22.8759 11.8404 22.8759 11.5809 22.8202C11.2638 22.7522 11.0241 22.6115 10.8394 22.503L10.7984 22.479C9.78626 21.8885 7.87222 20.6576 6.19932 18.9148C4.53756 17.1836 3.00026 14.827 3.00026 12.0004L3.00013 7.07849C2.99918 6.41904 2.99834 5.83992 3.19641 5.31941C3.36968 4.86407 3.65124 4.45778 4.01675 4.13565C4.43457 3.76743 4.97712 3.56488 5.59491 3.33422L11.0873 1.2747L11.1306 1.25839C11.2922 1.19737 11.4956 1.12051 11.7142 1.08892ZM16.2074 9.70759C16.5979 9.31707 16.5979 8.68391 16.2074 8.29338C15.8168 7.90286 15.1837 7.90286 14.7931 8.29338L11.0002 12.0863L9.70735 10.7934C9.31683 10.4029 8.68366 10.4029 8.29314 10.7934C7.90261 11.1839 7.90261 11.8171 8.29314 12.2076L10.2931 14.2076C10.6837 14.5981 11.3168 14.5981 11.7074 14.2076L16.2074 9.70759Z",
			fill: "url(#paint0_linear_356_6781)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.2071 9.70711C16.5976 9.31658 16.5976 8.68342 16.2071 8.29289C15.8166 7.90237 15.1834 7.90237 14.7929 8.29289L11 12.0858L9.70711 10.7929C9.31658 10.4024 8.68342 10.4024 8.29289 10.7929C7.90237 11.1834 7.90237 11.8166 8.29289 12.2071L10.2929 14.2071C10.6834 14.5976 11.3166 14.5976 11.7071 14.2071L16.2071 9.70711Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_356_6781",
			x1: 12.0003,
			y1: 1.06836,
			x2: 12.0003,
			y2: 22.862,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF537F" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#641EDC"
			})]
		}) })
	]
});
export default SvgShieldIconNew;
